import "@uiw/react-textarea-code-editor/dist.css";
import "./App.css";

import { Route, Switch } from "react-router-dom";
import LoginPage from "pages/Authentication/LoginPage";
import PasswordResetPage from "pages/Authentication/PasswordResetPage";
import NotFoundPage from "pages/NotFoundPage";
import PrivateRoute from "components/PrivateRoute";
import PasswordResetEmailPage from "pages/Authentication/PasswordResetEmailPage";
import ZendeskRedirectPage from "pages/Authentication/ZendeskRedirectPage";
import RootPage from "pages/RootPage";
import OAuthLoginCallback from "pages/Authentication/OAuthLoginCallback";
import SomethingWentWrong from "pages/SomethingWentWrong";

function App() {
  return (
    <Switch>
      <Route exact path="/health">
        <div>OK</div>
      </Route>

      <Route exact path="/login">
        <LoginPage />
      </Route>

      <Route exact path="/forgotpassword">
        <PasswordResetEmailPage />
      </Route>

      <Route exact path="/resetpassword">
        <PasswordResetPage />
      </Route>

      <Route exact path="/helpdesklogin">
        <ZendeskRedirectPage />
      </Route>

      <Route exact path="/sso_callback">
        <OAuthLoginCallback />
      </Route>

      <Route exact path="/something-went-wrong">
        <SomethingWentWrong />
      </Route>

      <PrivateRoute path="/">
        <RootPage />
      </PrivateRoute>

      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  );
}

export default App;
